module.exports = __webpack_public_path__ + "resources/image_placeholder-efdfd2f61c9fa61b1cd72e836a71cac5.png";